<div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary"
     style="height: 100%;min-height:100%;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-7 col-xl-5 my-5">

        <div class="text-center">

          <!-- Preheading -->
          <h6 class="text-uppercase text-muted mb-4">
            Déconnexion réussie
          </h6>

          <!-- Heading -->
          <h1 class="display-4 mb-3">
            Vous vous êtes bien déconnecté
          </h1>

          <!-- Subheading -->
          <!--          <p class="text-muted mb-4">-->
          <!--            Vous avez des questions? Contactez-nous à l'adresse suivante: <a href="mailto:info@opti-impot.ca">info@opti-impot.ca</a>-->
          <!--          </p>-->

          <!-- Button -->
          <a class="btn btn-lg btn-primary" routerLink="/login">
            Se reconnecter
          </a>

        </div>

      </div>
    </div> <!-- / .row -->
  </div>
</div>
